module.exports = __webpack_public_path__ + "media/rendering/renderingSlide1-37e33d7e.png";